import {
  getLat,
  getLng,
  setLat,
  setLng,
} from '@/utils/cookies';

export const getCurrentPosition = (): Promise<{ lat: number, lng: number, isMobile: boolean }> => {
  return new Promise((resolve, reject) => {
    let lat = getLat();
    let lng = getLng();
    let isMobile = false;

    if (lat && lng) {
      // console.log('위치 정보가 쿠키에 저장되어 있습니다.');
      resolve({ lat: parseFloat(lat), lng: parseFloat(lng), isMobile: false });
    } else if (navigator.userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Windows Phone|Mobile|Tablet/i)) {
      // console.log('모바일 브라우저에서 위치 정보를 가져옵니다.');
      navigator.geolocation.getCurrentPosition(
        (position) => {
          lat = position.coords.latitude;
          lng = position.coords.longitude;
          isMobile = true;
          setLat(lat);
          setLng(lng);
          resolve({ lat, lng, isMobile });
        },
        (error) => {
          console.error('위치 정보 가져오기 실패:', error);
          lat = parseFloat((Math.random() * (34.88957198305561 - 34.88445926852321) + 34.88445926852321).toFixed(6));
          lng = parseFloat((Math.random() * (127.89031601550143 - 127.8174539194058) + 127.8174539194058).toFixed(6));
          resolve({ lat, lng, isMobile: false });
        },
      );
    } else {
      // console.log('PC 브라우저에서는 위치 정보를 가져오지 않습니다.');
      lat = parseFloat((Math.random() * (34.88957198305561 - 34.88445926852321) + 34.88445926852321).toFixed(6));
      lng = parseFloat((Math.random() * (127.89031601550143 - 127.8174539194058) + 127.8174539194058).toFixed(6));
      resolve({ lat, lng, isMobile: false });
    }
  });
};

/* 현재 위치 정보 */
export const userMapInstance = () => {
  if ('geolocation' in navigator) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        // location.lat = position.coords.latitude;
        // location.len = position.coords.longitude;
        // this.initMap(lat, lng);
      },
      (error) => {
        console.error('현재위치정보를 가져오는 중 오류가 발생하였습니다.', error);
      },
    );
  } else {
    console.error('예기치 못한 오류가 발생하였습니다.');
  }
  // return location;
};
